import { render } from "./PartnerRegistration.vue?vue&type=template&id=4a603438&scoped=true"
import script from "./PartnerRegistration.vue?vue&type=script&lang=js"
export * from "./PartnerRegistration.vue?vue&type=script&lang=js"

import "./PartnerRegistration.vue?vue&type=style&index=0&id=4a603438&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a603438"]])

export default __exports__